import {GraphQLClient, gql} from 'graphql-request';

const endpoint = process.env.REACT_APP_API_ENDPOINT;

const createPhoto = async (vars) => {
  const {photo, headers} = vars;
  const graphQLClient = new GraphQLClient(endpoint, {
    headers,
  });

  const mutation = gql`
      mutation createPhoto($path: String!, $name: String!, $width: Int!, $height: Int!){
        createPhoto(photo: {path: $path, name: $name, width: $width, height: $height}) {
            id
        }
      }`;

  const data = await graphQLClient.request(mutation,
      {
        name: photo.fileName,
        path: photo.photoKey,
        width: photo.imageWidth,
        height: photo.imageHeight,
      });

  return data;
};


const deletePhoto = async (vars) => {
  const {headers} = vars;
  const graphQLClient = new GraphQLClient(endpoint, {
    headers,
  });

  const mutation = gql`
      mutation deletePhoto($photoId: String!){
        deletePhoto(photoId: $photoId)
      }`;

  const data = await graphQLClient.request(mutation, vars);

  return data;
};


/**
 *
 * @return {*}
 */
export {createPhoto, deletePhoto};
